var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import Flex from "../../templates/flex";
var Container = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14),\n    0 3px 14px 2px rgba(0, 0, 0, 0.12);\n  list-style-type: none;\n"], ["\n  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14),\n    0 3px 14px 2px rgba(0, 0, 0, 0.12);\n  list-style-type: none;\n"])));
var Dropdown = function (_a) {
    var value = _a.value, onItemClick = _a.onItemClick, items = _a.items, renderItem = _a.renderItem;
    return (React.createElement(Container, { as: "ul", role: "listbox", background: "dropdown", padding: [0], margin: [1, 0], column: true, tabindex: "-1" }, items.map(function (item) { return renderItem({ item: item, value: value, onItemClick: onItemClick }); })));
};
export default Dropdown;
var templateObject_1;
